import Component from '@glimmer/component';
import { action } from '@ember/object';

export default class FilterItemComponent extends Component {
  @action
  changeDate(date) {
    this.args.onValueChange(this.args.filter, date);
  }
}
